import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SwitchPlanModal = ({ show, onHide }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
             <Modal.Body className="text-center p-4">
                <div className="mb-3">
                    <i className="ri-information-line fs-1 text-primary"></i>
                </div>
                <h4 className="fw-bold">Plan Switch Request Received</h4>
                <p className="text-muted mt-3">
                    Thank you for your request to switch plans. Your request has been recorded.
                </p>
                <p className="text-muted">
                    Our support team will contact you very soon to assist with the transition.
                </p>
                <Button variant="primary" onClick={onHide} className="mt-3">
                    OK
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default SwitchPlanModal;